'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
// TODO: Implement with Base UI Pagination
import BasePagination from "rc-pagination";
import { Icon } from "../Icon/index.js";
import { Button } from "../Button/index.js";
const buttonProps = {
    as: 'a',
    rootElementName: 'a',
    shape: 'circle',
    width: 'auto',
    size: 'xs',
    color: 'transparent'
};
const itemRender = (page, type, element, current)=>{
    if (type === 'page') {
        return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({}, buttonProps), {
            className: "font-medium",
            color: page === current ? 'primary' : 'transparent',
            "aria-current": page === current ? true : undefined,
            "aria-label": `Page ${page}`,
            children: page
        }));
    }
    if (type === 'prev') {
        return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({}, buttonProps), {
            "aria-label": "Previous Page",
            children: /*#__PURE__*/ _jsx(Icon, {
                icon: "chevron-left",
                className: "text-primary"
            })
        }));
    }
    if (type === 'next') {
        return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({}, buttonProps), {
            "aria-label": "Next Page",
            children: /*#__PURE__*/ _jsx(Icon, {
                icon: "chevron-right",
                className: "text-primary"
            })
        }));
    }
    if (type === 'jump-prev' || type === 'jump-next') {
        return /*#__PURE__*/ _jsx("button", {
            type: "button",
            className: "text-sm font-medium h-full w-8 leading-8 cursor-not-allowed select-none",
            onClick: (e)=>e.stopPropagation(),
            "aria-disabled": true,
            disabled: true,
            children: "..."
        });
    }
    return element;
};
/**
 * Pagination - [API](https://scl.sharp.com/?path=/docs/components-pagination) | [DSM](https://sharphealthcare.notion.site/Pagination-39ba3d32e47148778c0061a7014ab124)
 */ function Pagination(_param) {
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("nav", {
        role: "navigation",
        "aria-label": "Pagination Navigation",
        className: className,
        children: /*#__PURE__*/ _jsx(BasePagination, _object_spread({
            className: "flex flex-row gap-1 md:gap-4 justify-center",
            itemRender: (page, type, element)=>itemRender(page, type, element, props.current),
            defaultPageSize: 1,
            showLessItems: true,
            locale: {
                // Options
                items_per_page: '/ page',
                jump_to: 'Go to',
                jump_to_confirm: 'confirm',
                page: 'Page',
                // Pagination
                prev_page: 'Previous Page',
                next_page: 'Next Page',
                prev_5: 'Previous 5 Pages',
                next_5: 'Next 5 Pages',
                prev_3: 'Previous 3 Pages',
                next_3: 'Next 3 Pages',
                page_size: 'Page Size'
            }
        }, props))
    });
}
export { Pagination };
